<template>
  <div>
    <b-modal
      id="urgency-picker-modal"
      ref="urgency-picker-modal-ref"
      hide-footer
      title="Contact Us"
    >
      <b-form-radio-group
        v-model="selection"
        stacked
        class="mt-2"
      >
        <b-form-radio value="in-trip" class="mb-3">
          My question is not urgent
        </b-form-radio>
        <b-form-radio value="urgent">
          I require urgent assistance
        </b-form-radio>
      </b-form-radio-group>
      <b-row class="mt-4 flex-row">
        <button
          :disabled="!selection"
          class="ml-lg-3 address-block-btn address-btn-submit justify-content-center"
          @click="confirm"
        >
          <span>Continue</span><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
        </button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selection: null,
    }
  },
  methods: {
    show() {
      this.selection = null
      this.$refs['urgency-picker-modal-ref'].show()
    },
    confirm() {
      if (!this.selection) return
      this.$emit('selected', this.selection)
      this.$refs['urgency-picker-modal-ref'].hide()
    },
  },
}
</script>
